import { h, defineComponent } from 'vue';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { col, cols } from '@/ui/components';
import { renderForbiddenPage } from '../../error/ForbiddenPage';
import { renderAnalyticsTeaserPage } from '../../teasers/AnalyticsTeaserPage';
import { NegativeResponsesCard } from '@/ui/pages/analytics/Overview/NegativeResponsesCard';
import { WorstScoresCard } from '@/ui/pages/analytics/Overview/WorstScoresCard';
import { OverviewCardsRow } from '@/ui/pages/analytics/Overview/OverviewCardsRow';
import { OverviewPageFilters } from '@/ui/pages/analytics/Overview/OverviewPageFilters';
import { MostOverdueInspectionsCard } from '@/ui/pages/analytics/Overview/MostOverdueInspectionsCard';
import { IssueStatusCard } from '@/ui/pages/analytics/Overview/IssueStatusCard';

export const OverviewPage = defineComponent(
  {
    name: 'OverviewPage',
    setup() {
      if (!hasFeature('analytics')) {
        return renderAnalyticsTeaserPage;
      }

      if (!hasPermission(Permissions.VIEW_ALL_ANALYTICS)) {
        return renderForbiddenPage;
      }

      return function render() {
        return h('div', [
          h('div', [
            h('div', { class: 'columns overview-page legacy-wrapper' }, [
              h(OverviewPageFilters),
              h('div', { class: 'column' }, [
                h('div', { class: 'legacy' }, [
                  h(OverviewCardsRow),
                  h('div', { class: 'overview-page__tables' }, [
                    cols([
                      col([
                        h(NegativeResponsesCard),
                      ], false, { 'is-half': true }),
                      col([
                        h(WorstScoresCard),
                      ], false, { 'is-half': true }),
                    ]),
                    cols([
                      col([
                        h(MostOverdueInspectionsCard),
                      ], false, { 'is-half': true }),
                      col([
                        h(IssueStatusCard),
                      ], false, { 'is-half': true }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]);
      };
    },
  },
);
